module.exports = __webpack_public_path__ + "static/img/logo-studio.6e48b96.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo/logo-studio.png
// module id = CmbA
// module chunks = 46